import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Button } from '@mui/material';

import useLicenseInfo from 'hooks/use-license-info';
import useTrialModal from 'hooks/use-trial-modal';

import useStyles from './styles';

const UpgradeLicenseButton = () => {
    const history = useHistory();
    const { modal, onAnchorClick } = useTrialModal();
    const { classes } = useStyles();

    const goToUserInfo = useCallback(() => history.push('/userinfo'), [history]);
    const { isTrial, canUpgrade } = useLicenseInfo();
    const handleClick = isTrial ? onAnchorClick : canUpgrade ? goToUserInfo : undefined;

    if (!isTrial && !canUpgrade) {
        return null;
    }

    return (
        <>
            <Button
                size="large"
                className={classes.buttonRoot}
                onClick={handleClick}
                variant="outlined"
                color="primary"
            >
                {isTrial ? (
                    'Start 30-day trial'
                ) : (
                    <>
                        <ArrowUpwardIcon className={classes.icon} />
                        Upgrade
                    </>
                )}
            </Button>
            {modal}
        </>
    );
};

export default observer(UpgradeLicenseButton);
